import _ from 'lodash';
import { createApiCallAction, createApiCallActionWithParams } from './utils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { makeApiCall } from '../../utils/makeApiCall';
import { serializeError } from '../../utils/errorHandling';

type UpdateCredentialPayload = {
  id: string;
  is_shared?: boolean;
  source_id?: string | null;
};

export const updateCredential = createAsyncThunk(
  'organization/updateCredential',
  async (payload: UpdateCredentialPayload, { rejectWithValue }) => {
    try {
      const data: Record<string, unknown> = {};
      if (payload.is_shared !== undefined) data.is_shared = payload.is_shared;
      if (payload.source_id !== undefined) data.source_id = payload.source_id;
      if (Object.keys(data).length === 0) {
        throw new Error(
          'updateCredential requires at least one field to update'
        );
      }
      return await makeApiCall({
        url: `/credentials/${payload.id}`,
        method: 'PATCH',
        data,
      });
    } catch (error) {
      return rejectWithValue(serializeError(error));
    }
  }
);

// Async thunk for fetching tool configs
export const fetchToolConfigs = createApiCallAction(
  'organization/fetchToolConfigs',
  {
    url: '/tool-configs',
    method: 'GET',
  }
);

// Async thunk for creating tool config
export const createToolConfig = createApiCallActionWithParams(
  'organization/createToolConfig',
  (params) => ({
    url: '/tool-configs',
    method: 'POST',
    data: params,
  })
);

// Async thunk for creating tool config
export const updateToolConfig = createApiCallActionWithParams(
  'organization/updateToolConfig',
  (params) => ({
    url: `/tool-configs/${params.id}`,
    method: 'PATCH',
    data: _.omit(params, 'id'),
  })
);
